import { Routes } from '@angular/router';
import { ProductComponent } from '../../product/product.component';
import { StudentImportComponent } from '../../student-import/student-import.component';
import { SubjectDictionaryImportComponent } from '../../subject-dictionary-import/subject-dictionary-import.component';
import { ResultImportComponent } from 'src/app/result-import/result-import.component';
import { ProcessResultsComponent } from 'src/app/process-results/process-results.component';
import { ProcessResultsListComponent } from 'src/app/process-results-list/process-results-list.component';

import { UserListComponent } from '../../user/user-list/user-list.component';
import { CourseMasterComponent } from 'src/app/course-master/course-master.component';
import { SemesterMasterComponent } from 'src/app/semester-master/semester-master.component';
import { CourseSemesterMappingComponent } from 'src/app/course-semester-mapping/course-semester-mapping.component';
import { SchemeMasterComponent } from 'src/app/scheme-master/scheme-master.component';
import { GradeMasterComponent } from 'src/app/grade-master/grade-master.component';

import { StaffAccountCreationComponent } from 'src/app/staff-account-creation/staff-account-creation.component';
import { StaffListComponent } from 'src/app/staff-list/staff-list.component';
import { StudentListComponent } from 'src/app/student-list/student-list.component';
import { SubjectListsComponent } from 'src/app/subject-lists/subject-lists.component';
import { GradeCardComponent } from 'src/app/grade-card/grade-card.component';
import { ResultsListComponent } from 'src/app/results-list/results-list.component';
import { MonthsComponent } from 'src/app/months/months.component';
import { YearsComponent } from 'src/app/years/years.component';
import { ChangeOfBranchComponent } from 'src/app/change-of-branch/change-of-branch.component';
import { ProcessedResultListComponent } from 'src/app/processed-result-list/processed-result-list.component';
import { ProcessedResultsStatsComponent } from 'src/app/processed-results-stats/processed-results-stats.component';
import { ResultMasterComponent } from 'src/app/result-master/result-master.component';
import { NADReportComponent } from 'src/app/nad-report/nad-report.component';
import { CollegeDataComponent } from 'src/app/college-data/college-data.component';
import { DateOfResultComponent } from 'src/app/date-of-result/date-of-result.component';
import { OverallResultComponent } from 'src/app/overall-result/overall-result.component';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
    {
        path: 'dashboard',
        loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule)
    },

    {
        path: 'charts',
        loadChildren: () => import('../../charts/charts.module').then(m => m.ChartsModule)
    },


    {
        path: 'profile',
        loadChildren: () => import('../../profile/profile.module').then(m => m.ProfileModule)
    },




    { path: 'staff-account-creation', component: StaffAccountCreationComponent },
    { path: 'student-import', component: StudentImportComponent },
    { path: 'subject-import', component: SubjectDictionaryImportComponent },
    { path: 'staff-list', component: StaffListComponent },
    { path: 'result-import', component: ResultImportComponent },
    { path: 'process-result', component: ProcessResultsComponent },
    { path: 'students-lists', component: StudentListComponent },
    { path: 'subject-lists', component: SubjectListsComponent },
    { path: 'result-processed-list', component: ProcessResultsListComponent },
    { path: 'result-processed-stats', component: ProcessedResultsStatsComponent },

    { path: 'result-lists', component: ResultsListComponent },
    { path: 'change-course-list', component: ChangeOfBranchComponent },
    { path: 'processed-result', component: ProcessedResultListComponent },
    { path: 'processss-result', component: ProcessResultsListComponent },

    //Settings
    { path: 'scheme-master', component: SchemeMasterComponent },
    { path: 'grade-master', component: GradeMasterComponent },
    { path: 'Course-master', component: CourseMasterComponent },
    { path: 'Semester-master', component: SemesterMasterComponent },
    { path: 'Course-semester-map', component: CourseSemesterMappingComponent },
    { path: 'months-list', component: MonthsComponent },
    { path: 'years-list', component: YearsComponent },
    { path: 'result-master', component: ResultMasterComponent },




    { path: 'process-result', component: ProcessResultsComponent },
    { path: 'Grade-card', component: GradeCardComponent },
    { path: 'NAD-report', component: NADReportComponent },
    { path: 'College-data', component: CollegeDataComponent },




    { path: 'user-list', component: UserListComponent },
    {path:'date-of-result',component:DateOfResultComponent},
    {path:'overallresult',component:OverallResultComponent},


];